export const SET_PROGRAMS_AND_REWARDS = 'setState_SET_PROGRAMS_AND_REWARDS';
export const SET_SELECTED_BEHAVIOIR = 'setState_SET_SELECTED_BEHAVIOR';
export const SET_SELECTED_PROGRAM = 'setState_SET_SELECTED_PROGRAM';